// Palatium product page panel
(function () {
  function init() {
    var container = document.querySelector('.product__info-container');
    if (!container || container.dataset.pltmInit) return;
    container.dataset.pltmInit = '1';

    // Hide unwanted blocks
    [
      '.product__text',
      '.product-form__quantity',
      '.product__share-summary',
      '.product__tax',
      '.installment',
      '.shopify-payment-button',
      'share-button',
      '.share-button',
    ].forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        el.style.display = 'none';
      });
    });

    // --- Title + Price row ---
    var titleEl = container.querySelector('.product__title');
    var priceEl = container.querySelector('[id^="price-"]');
    if (titleEl && priceEl) {
      var row = document.createElement('div');
      row.className = 'pltm-title-row';
      titleEl.parentNode.insertBefore(row, titleEl);
      row.appendChild(titleEl);
      row.appendChild(priceEl);
    }

    // --- SIZE accordion ---
    // Move the WHOLE variant-selects/variant-radios element so Dawn's JS listeners stay intact
    var variantWrapper = container.querySelector('variant-selects')
      || container.querySelector('variant-radios');
    if (!variantWrapper) {
      var firstInput = container.querySelector('.product-form__input');
      if (firstInput) variantWrapper = firstInput.parentElement;
    }
    if (variantWrapper) {
      var sizeBody = wrapInAccordion('SIZE', variantWrapper, [variantWrapper]);
      // Image comes from the section's own "Size Chart" setting (main-product.liquid renders a
      // hidden #pltm-size-chart-data element with the URL when one is set) rather than a theme
      // setting — this way it's per-section, matching where the merchant actually uploads it.
      var chartDataEl = document.getElementById('pltm-size-chart-data');
      var sizeGuideImageUrl = chartDataEl ? chartDataEl.dataset.url : '';
      var guideLink = null;
      if (sizeGuideImageUrl) {
        guideLink = document.createElement('button');
        guideLink.type = 'button';
        guideLink.className = 'pltm-size-guide-link';
        guideLink.textContent = 'size guide';
        sizeBody.insertBefore(guideLink, variantWrapper);
        guideLink.addEventListener('click', function () {
          openSizeGuideModal(sizeGuideImageUrl);
        });
      }

      // Optional per-product sizing tip (custom.sizing_note metafield) — sits right after the
      // size guide button; blank on virtually every product, so it only renders when set.
      var sizingNoteEl = document.getElementById('pltm-sizing-note-data');
      if (sizingNoteEl && sizingNoteEl.textContent.trim()) {
        var noteEl = document.createElement('p');
        noteEl.className = 'pltm-size-note';
        noteEl.textContent = sizingNoteEl.textContent.trim();
        sizeBody.insertBefore(noteEl, guideLink ? guideLink.nextSibling : variantWrapper);
      }
    }

    // --- DESCRIPTION accordion --- always show even if empty
    var descEl = container.querySelector('.product__description');
    if (!descEl) {
      descEl = document.createElement('div');
      descEl.className = 'product__description';
    }
    wrapInAccordion('DESCRIPTION', descEl, [descEl]);

    // --- SHIPPING accordion --- pairs with DESCRIPTION specifically (see custom.css, targeted
    // by nth-child since accordion order is always SIZE, DESCRIPTION, SHIPPING): sits beside it
    // on desktop, below it on mobile. Kept short and to the point rather than the full shipping
    // policy text — this is a quick answer, not the place for the whole policy (that's linked
    // from the Info page).
    // descEl is now nested inside DESCRIPTION's own accordion body (wrapInAccordion just moved
    // it there), so its accordion wrapper — not descEl itself — is the sibling to insert next to.
    var descAccordion = descEl.closest('.pltm-accordion');
    var shippingEl = document.createElement('div');
    shippingEl.className = 'product__description pltm-shipping-text';
    // The rich-text metafield already renders as block-level HTML (its own <p> tags), so it's used
    // as-is; the plain-string fallback isn't, so it gets wrapped in one.
    var shippingDataEl = document.getElementById('pltm-shipping-data');
    shippingEl.innerHTML = shippingDataEl && shippingDataEl.innerHTML.trim()
      ? shippingDataEl.innerHTML.trim()
      : '<p>Orders ship within 3–5 business days. Delivery takes another 2–5 business days within the US. International delivery times vary by destination.</p>';
    descAccordion.parentNode.insertBefore(shippingEl, descAccordion.nextSibling);
    wrapInAccordion('SHIPPING', shippingEl, [shippingEl]);

    // --- Put both accordions side by side ---
    var allAccordions = Array.from(container.querySelectorAll('.pltm-accordion'));
    if (allAccordions.length >= 2) {
      var accRow = document.createElement('div');
      accRow.className = 'pltm-accordions-row';
      allAccordions[0].parentNode.insertBefore(accRow, allAccordions[0]);
      allAccordions.forEach(function(acc) { accRow.appendChild(acc); });
    }

    // --- Style the buy button but DO NOT move it (moving breaks the form) ---
    var productFormEl = container.querySelector('product-form');
    if (productFormEl) {
      productFormEl.classList.add('pltm-buy-row');
    } else {
      var buyBtn = container.querySelector('.product-form__buttons');
      if (buyBtn) buyBtn.classList.add('pltm-buy-row');
    }

    container.classList.add('pltm-panel');

    // Enforce sold-out states immediately and on variant changes
    enforceDisabled();
    document.addEventListener('change', function() {
      setTimeout(enforceDisabled, 80);
    });
    document.addEventListener('variant:change', function() {
      setTimeout(enforceDisabled, 80);
    });
  }

  function enforceDisabled() {
    var selectors = [
      '.swatch-input__input:disabled',
      '.swatch-input__input.disabled',
      'input[type="radio"]:disabled',
      'input[type="radio"].disabled',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(input) {
      var wrapper = input.closest('.swatch-input__wrapper');
      if (wrapper) {
        wrapper.style.pointerEvents = 'none';
        wrapper.style.cursor = 'not-allowed';
      }
      var label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL') {
        label.style.pointerEvents = 'none';
        label.style.cursor = 'not-allowed';
      }
    });
  }

  function wrapInAccordion(label, insertBefore, contents) {
    var wrap = document.createElement('div');
    wrap.className = 'pltm-accordion';

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'pltm-accordion__trigger';
    trigger.innerHTML =
      '<span class="pltm-accordion__label">' + label + '</span>' +
      '<span class="pltm-accordion__arrow"></span>';

    var body = document.createElement('div');
    body.className = 'pltm-accordion__body';

    insertBefore.parentNode.insertBefore(wrap, insertBefore);
    wrap.appendChild(trigger);
    wrap.appendChild(body);
    contents.forEach(function(el) { body.appendChild(el); });

    trigger.addEventListener('click', function () {
      var isOpen = wrap.classList.contains('pltm-open');

      // Close all open accordions with explicit height (smooth)
      document.querySelectorAll('.pltm-accordion.pltm-open').forEach(function(a) {
        var b = a.querySelector('.pltm-accordion__body');
        b.style.height = b.scrollHeight + 'px';
        b.offsetHeight;
        b.style.height = '0';
        a.classList.remove('pltm-open');
        a.querySelector('.pltm-accordion__arrow').innerHTML = '';
      });

      if (!isOpen) {
        wrap.classList.add('pltm-open');
        var naturalHeight = body.scrollHeight;
        body.style.height = '0';
        body.offsetHeight;
        body.style.height = naturalHeight + 'px';
        trigger.querySelector('.pltm-accordion__arrow').innerHTML = '';
        body.addEventListener('transitionend', function onEnd() {
          body.style.height = 'auto';
          body.removeEventListener('transitionend', onEnd);
        });
      }
    });

    return body;
  }

  // --- Size guide modal — full-screen, dark, shows a single merchant-uploaded image ---
  var sizeGuideModal = null;

  function openSizeGuideModal(imageUrl) {
    if (!sizeGuideModal) {
      sizeGuideModal = document.createElement('div');
      sizeGuideModal.className = 'pltm-size-guide-modal';
      sizeGuideModal.innerHTML =
        '<div class="pltm-size-guide-modal__header">' +
          '<span class="pltm-size-guide-modal__brand">' + (window.pltmShopName || document.title) + '</span>' +
          '<button type="button" class="pltm-size-guide-modal__close">CLOSE</button>' +
        '</div>' +
        '<div class="pltm-size-guide-modal__body">' +
          '<img src="' + imageUrl + '" alt="Size guide">' +
        '</div>';
      document.body.appendChild(sizeGuideModal);

      sizeGuideModal.querySelector('.pltm-size-guide-modal__close').addEventListener('click', closeSizeGuideModal);
      sizeGuideModal.addEventListener('click', function (e) {
        if (e.target === sizeGuideModal) closeSizeGuideModal();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSizeGuideModal();
      });
    }
    sizeGuideModal.classList.add('is-open');
    document.body.classList.add('pltm-size-guide-open');
  }

  function closeSizeGuideModal() {
    if (sizeGuideModal) sizeGuideModal.classList.remove('is-open');
    document.body.classList.remove('pltm-size-guide-open');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
